import styles from "./MultiPopProductionsStarterPopupConfirmationButtons.module.scss";

import { IonButton } from "@ionic/react";
import { useState } from "react";
import productionController from "../../../../../barrel/controllers/productionController";
import useLocalStorageHandler from "../../../../../barrel/hooks/useLocalStorageHandler";

interface IProps {
  onCancelAllClick: any;
  onClickConfirm: any;
  enabled: boolean;
  enabledCancelAll: boolean;
}
function MultiPopProductionsStartedConfirmationButtons(props: IProps) {
  return (
    <div className={styles.container}>
      <div className={styles.lineBreaker}></div>
      <div className={styles.buttonsContainer}>
        <div className={styles.confirmationContainer}>
          <div>
            <div>
              <IonButton
                disabled={!props.enabled}
                className={styles.confirmButton}
                onClick={() => {
                  if (props.onClickConfirm) {
                    props.onClickConfirm();
                  }
                }}
              >
                CONTINUE
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiPopProductionsStartedConfirmationButtons;
